<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <div class="r">
        <!--  v-if="backRole('SM_2')" -->
        <el-button type="primary" @click="addConsumableTypeBtnClick()" size="mini">新增易耗品类别</el-button>
      </div>
      <el-col class="item-input" :span="12">
        <label>搜索：</label>
        <el-input v-model="filterKey" size="mini" placeholder="你可以搜索易耗品类别名称/易耗品类别编码"></el-input>
      </el-col>
    </div>
    <el-table :data="paginationData" style="width: 100%" v-loading="loading">
      <el-table-column type="index" label="序号" align="center" width="100">
      </el-table-column>
      <el-table-column prop="num" label="类别编码" width="120" align="center">
      </el-table-column>
      <el-table-column prop="name" label="易耗品类别" align="left">
      </el-table-column>
      <el-table-column label="操作" width="200" align="right">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="编辑该易耗品类别" placement="bottom">
            <i class="iconfont icon-xiugai meeting-btn-icon mbi-edit" @click="editConsumableTypeBtnClick(scope.row)"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除该易耗品类别" placement="bottom">
            <i class="iconfont icon-close meeting-btn-icon mbi-remove" @click="deleteConsumableType(scope.row)"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length" @current-change="handleCurrentChange">
    </el-pagination>

    <!-- 添加易耗品类别 -->
    <div class="pop-room" v-if="addConsumableTypeStatus">
      <a href="javascript:;" @click="addConsumableTypeStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="22">
          <el-form ref="form" :model="form" label-width="120px" class="form" @submit.native.prevent>
            <el-form-item label="易耗品类别名字">
              <el-input size="small" v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-button @click="submitConsumableType()" class="form-btn" type="success">确认提交</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";
  export default {
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        addConsumableTypeStatus: false,

        form: {
          // 默认指定depid是一司，为以后可能分来各水司做保留
          depId: 2,
          name: ""
        },
        formType: 0,

        // 列表
        loading: true,
        pageSize: 50,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
        filterKey: "",
      }
    },
    mounted() {
      this.getLists()
    },
    components: {},
    methods: {
      // 编辑易耗品类别按钮点击
      editConsumableTypeBtnClick(row) {
        this.addConsumableTypeStatus = true
        this.form.dlId = row.id
        this.form.name = row.name
        this.formType = 1
      },
      // 新增易耗品类别按钮点击
      addConsumableTypeBtnClick() {
        this.addConsumableTypeStatus = true
        this.form.name = ""
        this.formType = 0
      },
      // 易耗品类别form提交
      submitConsumableType() {
        let _url = this.formType == 0 ? '/consumable/dl/add' : '/consumable/dl/edit'
        ajax.post(_url, this.form, (res) => {
          this.addConsumableTypeStatus = false
          this.$message.success("提交成功")
          this.getLists()
        })
      },
      // 删除易耗品类别
      deleteConsumableType(row) {
        this.$confirm('此操作将永久删除该易耗品类别, 易耗品类别请勿随意删除，是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ajax.post('/consumable/dl/del', {
            dlId: row.id
          }, (res) => {
            this.$message.success("删除易耗品类别成功")
            this.getLists()
          })
        }).catch(() => {});
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        console.log(this.filterKey)
        if (this.filterKey) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _new = this.listData[i]
            if (_new.name.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1 || _new.num.indexOf(this.filterKey) != -1) {
              this.filterData.push(_new)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this.currentPage)
      },
      // 获取列表
      getLists() {
        ajax.get('/consumable/dl/list', {
          depId: 2
        }, (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {
      filterKey() {
        this.getFilterData()
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/consumable/consumableTypeList.vue